// educationData.js
export const education = [
  {
    year: "2020",
    title: "UP Board",
    institute: "Adarsh Inter College",
    score: "82.3%",
    side: "left",
  },
  {
    year: "2022",
    title: "UP Board",
    institute: "Govt. City Inter College",
    score: "77.3%",
    side: "right",
  },
  {
    year: "2023",
    title: "B.Tech. in Information Technology",
    institute: "GGSIPU University",
    score: "CGPA: 8.17",
    side: "left",
  },
];
